import LayoutConciliacaoEmbed from '../../componentes/LayoutConciliacaoEmbed.vue';
import Sessao from './componentes/Sessao.vue';
import ConciliacaoLista from './componentes/ConciliacaoLista.vue';
import ConciliacaoBancoLista from './componentes/ConciliacaoBancoLista.vue';
import ConciliacaoTela from './componentes/ConciliacaoTela.vue';
import PosicaoTesourariaLista from './componentes/PosicaoTesourariaLista.vue';
import permissoesConciliacao from '~js/permissoes-conciliacao';

function exigirConsulta(modo) {
  return (para, de, next) => {
    if (permissoesConciliacao.consultar(modo)) {
      next();
      return;
    }

    if (modo === 'tesouraria') {
      next(false);
      return;
    }

    const outro = modo === 'banco' ? 'projeto' : 'banco';

    if (permissoesConciliacao.consultar(outro)) {
      next({ name: outro === 'banco' ? 'conciliacao-banco' : 'conciliacao-projeto' });
      return;
    }

    next(false);
  };
}

export default {
  path: '/conciliacao-projeto',
  component: LayoutConciliacaoEmbed,
  children: [
    {
      path: '',
      name: 'conciliacao-projeto.sessao',
      component: Sessao,
    },
    {
      path: 'lista',
      name: 'conciliacao-projeto',
      component: ConciliacaoLista,
      beforeEnter: exigirConsulta('projeto'),
    },
    {
      path: 'tela/:idProjetoCript',
      name: 'conciliacao-projeto.tela',
      component: ConciliacaoTela,
      meta: { modo: 'projeto' },
      beforeEnter: exigirConsulta('projeto'),
    },
    {
      path: 'banco-lista',
      name: 'conciliacao-banco',
      component: ConciliacaoBancoLista,
      beforeEnter: exigirConsulta('banco'),
    },
    {
      path: 'banco/:idContaCript',
      name: 'conciliacao-banco.tela',
      component: ConciliacaoTela,
      meta: { modo: 'banco' },
      beforeEnter: exigirConsulta('banco'),
    },
    {
      path: 'tesouraria',
      name: 'posicao-tesouraria',
      component: PosicaoTesourariaLista,
      beforeEnter: exigirConsulta('tesouraria'),
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/rotas.js